<template>
  <div class="c-items">
    <div class="date">{{ info.startTime }}</div>
    <div class="image-box">
      <span
        class="m-label-status"
        :class="info.webinarStatus"
        v-if="isShowStatus"
        >{{ info.webinarStatus | webinarStatus }}</span
      >
      <div class="image" @click="goto()">
        <img :src="info.coverUrl || './images/img01.jpg'" />
      </div>
      <div class="step" v-if="info.type == 2 || type == 2">
        {{ info.duration }}
      </div>
      <div class="play" v-if="info.type == 2 || type == 2" @click="goto()">
        <img src="../assets/images/icon-index-play.png" />
      </div>
    </div>
    <div class="title" @click="goto()">{{ info.title }}</div>
    <div class="tips">
      <div class="type" :title="info.categoryValue">
        {{ info.categoryValue }}
      </div>
      <div class="count" v-if="tempSett.bottomConfig.isShowSeeCount != 'false'">
        <a-icon type="eye" class="icon"></a-icon>
        <span>{{ info.viewCount || info.viewNumber || 0 }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { interact } from "fire-wind-water/tools/interact";

export default {
  name: "Items",
  data() {
    return {
      tempSett: {}
    };
  },
  created() {
    this.tempSett = this.$store.getters.getterTempConfig;
  },
  props: {
    isShowStatus: Boolean,
    info: {},
    type: null
  },
  methods: {
    goto() {
      if (interact.isMobile == 1) {
        window.location.href = this.info.wapUrl;
      } else {
        window.open(this.info.pcUrl);
      }
    }
  },
  computed: {
    tempConfig() {
      return this.$store.getters.getterTempConfig;
    }
  },
  watch: {
    tempConfig(val) {
      this.tempSett = val;
    }
  },
  filters: {
    webinarStatus: function(value) {
      var result = "";
      switch (value) {
        case "toBeRelease":
          result = "待发布";
          break;
        case "toBeLaunch":
          result = "未开始";
          break;
        case "launch":
          result = "进行中";
          break;
        case "completed":
          result = "已结束";
          break;
        case "completing":
          result = "已结束";
          break;
        case "replay":
          result = "回放";
          break;
      }
      return result;
    }
  }
};
</script>

<style scoped></style>
